import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import CompareIcon from 'mdi-react/ScaleBalanceIcon';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

const CompareProductToggle = ({ active, activate, deactivate }) => {
  const { t } = useContext(AppContext);
  const label = active
    ? t('product', 'product-compare.cancel-compare')
    : t('product', 'product-compare.choose-products');

  return (
    <S.Tooltip placement="left" title={label}>
      <S.CompareProductButton
        active={active}
        onClick={active ? deactivate : activate}
        label={label}
        aria-label={label}
      >
        <CompareIcon size={24} />
      </S.CompareProductButton>
    </S.Tooltip>
  );
};

CompareProductToggle.propTypes = {
  active: PropTypes.bool,
  activate: PropTypes.func,
  deactivate: PropTypes.func,
};

CompareProductToggle.defaultProps = {
  active: false,
  activate: () => {},
  deactivate: () => {},
};

export default memo(CompareProductToggle);
